import AuthenticatedResource from 'resources/public/AuthenticatedResource'

export default class NewsletterResource extends AuthenticatedResource {
  static urlRoot = '/organizations/:organization_id/newsletters' as const;

  readonly id: number | undefined = undefined;

  pk() {
    return this.id?.toString();
  }
}
